import { Routes, Route, useLocation } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { MainLayout } from '@/layouts/MainLayout'
import { AdminLayout } from '@/layouts/AdminLayout'
import PageTransition from '@/components/page-transition'

// Pages
import HomePage from '@/pages/HomePage'
import ProductsPage from '@/pages/ProductsPage'
import ProductDetailPage from '@/pages/ProductDetailPage'
import CategoriesPage from '@/pages/CategoriesPage'
import CategoryDetailPage from '@/pages/CategoryDetailPage'
import AboutPage from '@/pages/AboutPage'
import ContactPage from '@/pages/ContactPage'
import CartPage from '@/pages/CartPage'
import FavoritesPage from '@/pages/FavoritesPage'

// Admin pages
import AdminLogin from '@/pages/admin/Login'
import AdminDashboard from '@/pages/admin/Dashboard'
import AdminProducts from '@/pages/admin/Products'
import AdminProductForm from '@/pages/admin/ProductForm'
import AdminCategories from '@/pages/admin/Categories'
import AdminOrders from '@/pages/admin/Orders'
import AdminHeroSlides from '@/pages/admin/HeroSlides'
import AdminTranslations from '@/pages/admin/Translations'
import AdminSettings from '@/pages/admin/Settings'

export function AppRoutes() {
    const location = useLocation()

    return (
        <AnimatePresence mode="wait">
            <Routes location={location} key={location.pathname}>
                {/* Main routes with header/footer */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<PageTransition><HomePage /></PageTransition>} />
                    <Route path="/products" element={<PageTransition><ProductsPage /></PageTransition>} />
                    <Route path="/products/:slug" element={<PageTransition><ProductDetailPage /></PageTransition>} />
                    <Route path="/categories" element={<PageTransition><CategoriesPage /></PageTransition>} />
                    <Route path="/categories/:slug" element={<PageTransition><CategoryDetailPage /></PageTransition>} />
                    <Route path="/about" element={<PageTransition><AboutPage /></PageTransition>} />
                    <Route path="/contact" element={<PageTransition><ContactPage /></PageTransition>} />
                    <Route path="/cart" element={<PageTransition><CartPage /></PageTransition>} />
                    <Route path="/favorites" element={<PageTransition><FavoritesPage /></PageTransition>} />
                </Route>

                {/* Admin routes */}
                <Route path="/admin" element={<AdminLayout />}>
                    <Route path="login" element={<PageTransition><AdminLogin /></PageTransition>} />
                    <Route index element={<PageTransition><AdminDashboard /></PageTransition>} />
                    <Route path="products" element={<PageTransition><AdminProducts /></PageTransition>} />
                    <Route path="products/new" element={<PageTransition><AdminProductForm /></PageTransition>} />
                    <Route path="products/:id/edit" element={<PageTransition><AdminProductForm /></PageTransition>} />
                    <Route path="categories" element={<PageTransition><AdminCategories /></PageTransition>} />
                    <Route path="orders" element={<PageTransition><AdminOrders /></PageTransition>} />
                    <Route path="hero-slides" element={<PageTransition><AdminHeroSlides /></PageTransition>} />
                    <Route path="translations" element={<PageTransition><AdminTranslations /></PageTransition>} />
                    <Route path="settings" element={<PageTransition><AdminSettings /></PageTransition>} />
                    <Route path="telegram" element={<PageTransition><AdminSettings /></PageTransition>} />
                </Route>
            </Routes>
        </AnimatePresence>
    )
}
